import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User, UserService } from '../shared';

@Component({
  templateUrl: 'ressupport.component.html',
  styleUrls: ['./style.component.css']
})

export class ResSupportComponent {
  public data: Object;
  currentUser: User;

  constructor(
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {

    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;

      }
    )
    if (this.route.snapshot.url[0].path == 'support') {
      this.currentUser.operationMessage = 'Support'
    }



  }


}






